import React from 'react'
import { useRouter } from 'next/router'
import { useUserContext } from './UserContext'
import { useMarketContext } from './MarketContext'
import { trackProductClicked } from '../helpers/tracking.js'
import Button from './Button'

const SelectProductButton = ({
  featured,
  product,
  fromPath,
  onClick, // override router functionality
  buttonText,
  ...rest
}) => {
  const router = useRouter()
  const { user } = useUserContext()
  const { selectedMarket } = useMarketContext()

  let pathname = `/checkout/${product?.id}`
  let query = {
    from: fromPath,
    selectedMarket: selectedMarket?.id || null
  }

  // if not logged in reidrect to signin then to checkout 
  if (!user?.id) {
    const onSuccess = `/checkout/${product?.id}?from=${fromPath}`
    pathname = '/signin'
    query = {
      onSuccess
    }
  }

  let params = (new URLSearchParams(query)).toString()
  params = params.toString()
  pathname = params ? pathname.concat(`?${params}`) : pathname

  const reroute = () => {
    trackProductClicked(product)
    router.push(pathname)
  }

  const customStyles = rest?.style ? rest.style : {}
  const styles = {
    maxWidth: 400,
    ...customStyles
  }

  return (
    <Button
      fill 
      large
      hover
      type="button" 
      disabled={!product}             
      onClick={onClick ? onClick : reroute }
      style={styles}
      {...rest}
    >
      {buttonText ? buttonText : (!featured ? 'Proceed to Checkout' : 'Join Now')}
    </Button>
  )
}

export default SelectProductButton
